import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import type { RootState, AppDispatch } from '../store'
import { fetchCurrentUser } from '../slices/authSlice'

interface OptionalAuthProps {
  children: React.ReactNode
}

export default function OptionalAuth({ children }: OptionalAuthProps) {
  const dispatch = useDispatch<AppDispatch>()
  const { checked, loading } = useSelector((state: RootState) => state.auth)

  useEffect(() => {
    if (!checked) {
      dispatch(fetchCurrentUser())
    }
  }, [dispatch, checked])

  if (!checked || loading) {
    return null
  }

  return <>{children}</>
}
